import { Box } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view';

export const TreePopoverContent = styled(Box)({
  width: '100%',
  maxWidth: '100%',
  maxHeight: 320,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 12,
  boxSizing: 'border-box',
});

export const CustomTreeItem = styled(TreeItem)(() => ({
  [`& .${treeItemClasses.content}`]: {
    cursor: 'pointer',
    width: '100%',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&[data-focused]': {
      backgroundColor: 'transparent',
    },
    '&[data-selected]': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
  },
  [`& .${treeItemClasses.iconContainer}`]: {
    color: 'rgba(0, 0, 0, 0.54)',
    '& svg': {
      fontSize: 24,
    },
  },
  [`& .${treeItemClasses.label}`]: {
    width: '100%',
  },
}));
